import { render, staticRenderFns } from "./JoinMeetingPerson.vue?vue&type=template&id=95bf31f8&scoped=true"
import script from "./JoinMeetingPerson.vue?vue&type=script&lang=js"
export * from "./JoinMeetingPerson.vue?vue&type=script&lang=js"
import style0 from "./JoinMeetingPerson.vue?vue&type=style&index=0&id=95bf31f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bf31f8",
  null
  
)

export default component.exports